import { defineComponent as _defineComponent } from 'vue'
import { type PropType, computed, onMounted, ssrRef, useContext, useRoute, useStore } from "@nuxtjs/composition-api";

import { useAmplitude } from "@/composables";
import { useCreatorShopPostsStore } from "@/store/creator-shop-posts";
import { getLtksStore } from "@/store/ltks";
import { getProfilesStore } from "@/store/profiles";
import { handleErrorStatusCode, handleServiceError } from "@/utils/api";
import { NOT_FOUND } from "@/utils/enums/http-codes";
import { withProductsRow } from "@/utils/services/LtkItemHeightCalculator";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkProfile',
  props: {
  showProducts: {
    type: Boolean,
    required: false,
    default: false,
  },
  profileId: {
    type: String,
    required: true,
  },
  ltkId: {
    type: String,
    required: false,
    default: undefined,
  },
  xsColumns: {
    type: Number,
    required: false,
    default: 2,
  },
  smColumns: {
    type: Number,
    required: false,
    default: 3,
  },
  mdColumns: {
    type: Number,
    required: false,
    default: 3,
  },
  lgColumns: {
    type: Number,
    required: false,
    default: 4,
  },
  xlColumns: {
    type: Number,
    required: false,
    default: 4,
  },
  onIntersecting: {
    type: Function as PropType<(entries: Array<IntersectionObserverEntry>) => null>,
    required: false,
    default: () => null,
  },
  denseFeed: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const context = useContext();
const route = useRoute();
const store = useStore();
const amplitude = useAmplitude();
const creatorShopPostsStore = useCreatorShopPostsStore();
const ltkStore = getLtksStore(store);
const profilesStore = getProfilesStore(store);

const paginate = ssrRef(false, "LtkProfile paginate");
const itemHeightFunction = computed(() => (props.showProducts ? withProductsRow : undefined));

const profile = computed(() => profilesStore.getProfileById(props.profileId));
const postIds = computed(() => {
  return creatorShopPostsStore.getFeed(props.profileId).ids.filter((id) => id !== props.ltkId);
});

const fetchPosts = async () => {
  if (!profile.value?.displayName) {
    return handleServiceError({
      context,
      error: {
        status: NOT_FOUND,
        errorCode: "profile-not-found",
        developerMessage: "No display name provided",
      },
      meta: {
        url: route.value.fullPath,
        ltkId: props.ltkId,
        profileId: props.profileId,
      },
    });
  }

  if (paginate.value || postIds.value.length === 0) {
    try {
      await creatorShopPostsStore.fetch();
    } catch (error) {
      handleServiceError({
        context,
        error: {
          status: handleErrorStatusCode(error),
          errorCode: "creator-shop-feed-error",
          developerMessage: `Error fetching creator shop feed for (${props.profileId})`,
        },
        originalError: error,
        meta: {
          url: route.value.fullPath,
          ltkId: props.ltkId,
          profileId: props.profileId,
        },
      });
    }
  }
  paginate.value = true;
};

const onPaging = () => {
  amplitude?.sendScrollEvent("/scroll/publisher", ltkStore.ltkFeed(props.profileId).ids.length);
  fetchPosts();
};

onMounted(() => {
  fetchPosts();
});

return { __sfc: true,props, context, route, store, amplitude, creatorShopPostsStore, ltkStore, profilesStore, paginate, itemHeightFunction, profile, postIds, fetchPosts, onPaging }
}

})